/* eslint-disable @typescript-eslint/naming-convention */
const sharedRoutes = {
  stopImpersonating: "/a/sessions/stop_impersonating",

  external: {
    support: "https://support.fullscript.com/",
    learnMoreReferral: "https://fullscript.com/learnmorereferral",
  },
} as const;

export { sharedRoutes };
